/** Client-side "the number moved" — best-effort, read-only, cached for 5 minutes. Never affects the frozen answer. */
const cache = new Map<string, { t: number; v: number }>()

export async function fetchLiveNow(source: string): Promise<number | null> {
  const hit = cache.get(source)
  if (hit && Date.now() - hit.t < 300000) return hit.v
  let v: number | null = null
  if (source === 'astros') {
    const d = await fetch('https://api.open-notify.org/astros.json').then((r) => r.json())
    v = Number(d.number)
  } else if (source === 'opensky') {
    const d = await fetch('https://opensky-network.org/api/states/all').then((r) => r.json())
    v = Array.isArray(d?.states) ? d.states.length : null
  }
  if (v != null && Number.isFinite(v)) cache.set(source, { t: Date.now(), v })
  return v
}
